var map = {
	"./1.png": 1425,
	"./10.png": 9077,
	"./11.png": 7452,
	"./12.png": 8135,
	"./13.png": 2350,
	"./14.png": 6913,
	"./2.png": 3994,
	"./3.png": 5907,
	"./4.png": 8508,
	"./5.png": 4421,
	"./6.png": 2942,
	"./7.png": 6087,
	"./8.png": 9728,
	"./9.png": 5977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 233;